/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TemplateFieldOptionInput
 */
export interface TemplateFieldOptionInput {
    /**
     * 
     */
    id?: string;
    /**
     * Human-readable label rendered next to the option in the signing flow.
     */
    label: string;
    /**
     * 
     */
    x: number;
    /**
     * 
     */
    y: number;
    /**
     * 
     */
    width: number;
    /**
     * 
     */
    height: number;
    /**
     * 
     */
    sort_order?: number;
}

/**
 * Check if a given object implements the TemplateFieldOptionInput interface.
 */
export function instanceOfTemplateFieldOptionInput(value: object): value is TemplateFieldOptionInput {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    return true;
}

export function TemplateFieldOptionInputFromJSON(json: any): TemplateFieldOptionInput {
    return TemplateFieldOptionInputFromJSONTyped(json, false);
}

export function TemplateFieldOptionInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateFieldOptionInput {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'label': json['label'],
        'x': json['x'],
        'y': json['y'],
        'width': json['width'],
        'height': json['height'],
        'sort_order': json['sort_order'] == null ? undefined : json['sort_order'],
    };
}

export function TemplateFieldOptionInputToJSON(json: any): TemplateFieldOptionInput {
    return TemplateFieldOptionInputToJSONTyped(json, false);
}

export function TemplateFieldOptionInputToJSONTyped(value?: TemplateFieldOptionInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'x': value['x'],
        'y': value['y'],
        'width': value['width'],
        'height': value['height'],
        'sort_order': value['sort_order'],
    };
}

